import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './App/Login/Login';
import Dashboard from './App/DashBoard/DashBoard';
import Approval from './App/Approval/Approval';
import Painter from './App/DashBoard/TableFlow/DealerFlow/Painter';
import Product from './App/DashBoard/TableFlow/PainterFlow/Product';
import DealerList from './App/Approval/DealerApprovalList/DealerList';
import PainterList from './App/Approval/PainterApprovalList/PainterList';
import ProductList from './App/Approval/ProductApprovalList/ProductList';
import ProcessOrder from './App/ProcessOrder/ProcessOrder';
import ScannedFileUpload from './App/ScannedFileUpload/ScannedFileUpload';
import Scheme from './App/CreateScheme/Scheme';
import CreateScheme from './App/CreateScheme/CreateScheme';
import SchemeDealerFile from './App/CreateScheme/SchemeDealerFile';
import SchemeMaterialFile from './App/CreateScheme/SchemeMaterialFile';

const ProtectedRoute = ({ children }) => {
  const userinfo = JSON.parse(sessionStorage.getItem('userinfo'));
  return userinfo ? children : <Navigate to="/" />;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/approval" element={<ProtectedRoute><Approval /></ProtectedRoute>} />
      <Route path="/dealer-flow/:dealerId" element={<ProtectedRoute><Painter /></ProtectedRoute>} />
      <Route path="/painter-flow/:dealerId/:painterId" element={<ProtectedRoute><Product /></ProtectedRoute>} />
      <Route path="/dealer-list/:date" element={<ProtectedRoute><DealerList /></ProtectedRoute>} />
      <Route path="/painter-list/:date/:dealerId" element={<ProtectedRoute><PainterList /></ProtectedRoute>} />
      <Route path="/product-list/:date/:dealerId/:painterId" element={<ProtectedRoute><ProductList /></ProtectedRoute>} />
      <Route path="/processOrder" element={<ProtectedRoute><ProcessOrder /></ProtectedRoute>} />
      <Route path="/ScannedFileUpload" element={<ProtectedRoute><ScannedFileUpload /></ProtectedRoute>} />
      <Route path="/Scheme" element={<ProtectedRoute><Scheme /></ProtectedRoute>} />
      <Route path="/CreateScheme" element={<ProtectedRoute><CreateScheme /></ProtectedRoute>} />
      <Route path="/SchemeDealerFile" element={<ProtectedRoute><SchemeDealerFile /></ProtectedRoute>} />
      <Route path="/SchemeMaterialFile" element={<ProtectedRoute><SchemeMaterialFile /></ProtectedRoute>} />
    </Routes>
  );
};

export default AppRoutes;
